module.exports = __webpack_public_path__ + "static/media/sortHighToLow.436fc8e8.svg";